import angular from 'angular';
import bannerMessageComponent from './bannerMessage.component';
import bannerMessageService from './bannerMessage.service';

let bannerMessageModule = angular.module('bannerMessage', []).component('bannerMessage', bannerMessageComponent)
  .service('bannerMessageService',bannerMessageService);

export default bannerMessageModule;



// WEBPACK FOOTER //
// ./app/common/bannerMessage/bannerMessage.js